/* eslint-disable import/prefer-default-export */

import fetch from "lib/fetch"
import { isSessionActive } from "lib/currentUser/session"
import { Mutex } from "async-mutex"

const CURRENT_USER_INFO_PATH = "/users/current.json"

class Cache {
  static currentUser() {
    Cache.fetchMutex ||= new Mutex()

    return Cache.fetchMutex.runExclusive(() => {
      if (Cache.currentUserValue != undefined) {
        return Promise.resolve(Cache.currentUserValue)
      }

      return fetch(CURRENT_USER_INFO_PATH)
        .then((data) => data.json())
        .then((user) => {
          Cache.currentUserValue = user
          return user
        })
    })
  }
}

/**
 * Promise to fetch the current user.
 *
 * @returns {Promise}
 */
export function currentUser() {
  if (!isSessionActive()) {
    return Promise.resolve({})
  }

  return Cache.currentUser()
}
